<template>
	<div>
		<div v-for="(value, name) in params" :key="name">
			<div v-if="value.length > 0" style="font-weight: bold">
				{{ name }}
			</div>
			<div v-for="colonne in value" :key="colonne">
				<b-container
					style="margin: 0px !important; padding: 0px !important">
					<b-row
						style="margin: 0px !important; padding: 0px !important">
						<b-col
							md="auto"
							style="
								margin: 0px !important;
								padding: 0px !important;
							">
							{{ colonne }}
						</b-col>
						<b-col>
							<b-input v-model="el.data[name][colonne]"></b-input>
						</b-col>
					</b-row>
				</b-container>
			</div>
		</div>
	</div>
</template>
<script>
	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";
	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	import { JSONEditor } from "@json-editor/json-editor";
	import uniqueId from "lodash.uniqueid";

	export default {
		props: {
			el: {
				required: true,
				type: Object,
			},
			parameters: {
				type: Object,
			},
		},
		data() {
			return {
				id: uniqueId(""),
				params: {},
			};
		},
		name: "draggable-component",
		methods: {},
		mounted: async function () {
			var self = this;
			const element = document.getElementById("jsoneditor-" + this.id);

			//console.log(this.parameters)

			//console.log(this.parameters.parameters)

			this.params = this.parameters.parameters[this.el.first_deep];

			var keys = Object.keys(this.params);
			for (var i = 0; i < keys.length; i++) {
				if (!this.el.data[keys[i]]) this.el.data[keys[i]] = {};
				for (var j = 0; j < this.params[keys[i]].length; j++) {
					if (!this.el.data[keys[i]][this.params[keys[i]][j]])
						this.el.data[keys[i]][this.params[keys[i]][j]] = "";
				}
			}
		},
	};
</script>
<style scoped>
	.card-title je-object__title {
		display: none;
	}
</style>
